<template>
  <AvatarGroup>
    <Avatar
      v-for="person in people"
      :key="person.id"
      :image="person.thumbnail"
      :label="person.thumbnail ? undefined : getInitials(person.name)"
      :class="{
        'bg-primary-50 text-primary': !person.thumbnail,
      }"
      aria-label=""
      aria-hidden="true"
      shape="circle"
      class="flex-shrink-0 text-xs font-semibold"
      style="width: 1.75rem; height: 1.75rem"
    />
  </AvatarGroup>
</template>

<script setup lang="ts">
interface Person {
  id: number
  name: string
  thumbnail?: string
}

defineProps<{
  people: Person[]
}>()

function getInitials(name: string) {
  const nameParts = name.trim().split(/\s+/).filter(Boolean)

  if (!nameParts.length) return '?'
  if (nameParts.length === 1) return nameParts[0][0].toUpperCase()

  const firstInitial = nameParts[0][0]
  const lastInitial = nameParts[nameParts.length - 1][0]
  return `${firstInitial}${lastInitial}`.toUpperCase()
}
</script>
